/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  addLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels/add`, { labels });
  }

  removeLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels/remove`, {
      labels,
    });
  }
}

export default new ConversationApi();
